import CopySectionsRedux from './copy_sections_redux';

export default CopySectionsRedux;
